import React from "react";
import { routeNames } from "utils/routeNames";

const Dashboard = React.lazy(() => import("dashboard/app/pages/Dashboard"));
const Progress = React.lazy(() => import("dashboard/app/pages/Progress"));
const Profile = React.lazy(() => import("dashboard/app/pages/Profile"));
const CourseOverview = React.lazy(
  () => import("dashboard/app/pages/course-overview")
);
const Interviews = React.lazy(() => import("dashboard/app/pages/interviews"));
const Interview = React.lazy(() => import("dashboard/app/pages/interview"));
const CourseModule = React.lazy(() => import("dashboard/app/pages/course-module"));

export const dashboardRoutes: {
  path: string;
  Component: React.LazyExoticComponent<() => JSX.Element>;
}[] = [
  {
    path: routeNames.courseModule,
    Component: CourseModule,
  },
  {
    path: routeNames.interview,
    Component: Interview,
  },{
    path: routeNames.dashboard,
    Component: Dashboard,
  },
  {
    path: routeNames.progress,
    Component: Progress,
  },
  {
    path: routeNames.profile,
    Component: Profile,
  },
  {
    path: routeNames.courseOverview,
    Component: CourseOverview,
  },
  {
    path: routeNames.interviews,
    Component: Interviews,
  }
];

const Login = React.lazy(() => import("dashboard/app/pages/Auth/Login"));
const Personalization = React.lazy(
  () => import("dashboard/app/pages/Auth/Personalization")
);
const Signup = React.lazy(() => import("dashboard/app/pages/Auth/SignUp"));
const ForgetPassword = React.lazy(
  () => import("dashboard/app/pages/Auth/ForgetPassword")
);
const ResetPassword = React.lazy(
  () => import("dashboard/app/pages/Auth/ResetPassword")
);

export const authRoutes: {
  path: string;
  Component: React.LazyExoticComponent<() => JSX.Element>;
}[] = [
  {
    path: routeNames.login,
    Component: Login,
  },
  {
    path: routeNames.signUp,
    Component: Signup,
  },
  {
    path: routeNames.forgetPass,
    Component: ForgetPassword,
  },
  {
    path: routeNames.resetPass,
    Component: ResetPassword,
  },
  {
    path: routeNames.personalization,
    Component: Personalization,
  },
  
];